import type { SVGProps } from "react";
export interface HandDollarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HandDollarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HandDollarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m11.297 4.278.004.051.002.006.003.003.007.01q.013.015.054.046c.134.097.401.21.854.3 1.238.247 2.732 1.106 2.732 2.83 0 1.231-.782 2.224-1.843 2.64a1.122 1.122 0 0 1-2.219.024A2.9 2.9 0 0 1 9.177 8.58l-.072-.193-.03-.112a1.124 1.124 0 0 1 2.122-.706l.043.107.03.075a.64.64 0 0 0 .187.218c.103.078.271.155.543.156.453 0 .703-.325.703-.601 0-.096-.028-.182-.148-.289a1.4 1.4 0 0 0-.514-.268l-.262-.067c-.563-.113-1.21-.304-1.736-.687-.584-.425-.996-1.076-.996-1.937q0-.053.004-.105l.002-.003c.046-1.16.853-1.984 1.837-2.342a1.123 1.123 0 0 1 2.218-.013c.84.298 1.427.921 1.715 1.608l.073.192.03.111a1.126 1.126 0 0 1-2.123.708l-.043-.107-.03-.075a.64.64 0 0 0-.187-.22c-.103-.077-.271-.155-.543-.155a.9.9 0 0 0-.573.185c-.113.094-.13.174-.13.213zM5.59 11.875c.67 0 1.335.094 1.978.28l3.14.906.197.05q.297.063.602.063h2.284a2.77 2.77 0 0 1 2.737 2.345l2.742-.989.282-.086a2.877 2.877 0 0 1 3.401 1.806l.087.282a2.875 2.875 0 0 1-1.808 3.404l-7.516 2.727a7.63 7.63 0 0 1-6.245-.47l-3.605-1.961a.9.9 0 0 0-.419-.107h-1.43a1.125 1.125 0 0 1 0-2.25h1.43c.522 0 1.036.13 1.494.38l3.605 1.962.257.13a5.38 5.38 0 0 0 4.145.201l7.516-2.727a.625.625 0 0 0 .406-.679l-.03-.123a.626.626 0 0 0-.802-.373l-.001.001-5.258 1.896-.096.035-.002-.002-.032.014a2.8 2.8 0 0 1-.858.134H9.938a1.125 1.125 0 0 1 0-2.25h3.851a.6.6 0 0 0 .159-.024l.045-.017a.525.525 0 0 0-.204-1.009h-2.283q-.543 0-1.074-.113l-.348-.088-3.141-.906a4.9 4.9 0 0 0-1.354-.192H2a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
